const TokenKey = "Token";

export function getToken() {
    return sessionStorage.getItem('Authorization');
}

export function setToken(token) {
    return localStorage.setItem(TokenKey, token);
}

export function removeToken() {
    return localStorage.removeItem(TokenKey);
}

export function getName() {
    return localStorage.getItem("name");
}

export function setName(name) {
    return localStorage.setItem("name", name);
}

export function removeName() {
    return localStorage.removeItem("name");
}
